export enum ErrorCode {
    Unknown = 'E20000',
    DepositFailInSbo = 'E21001',
}
